import React from 'react';
import { Form } from 'react-bootstrap';
import './Input.css';

const input = ( props ) => {
    let inputElement = null;
    const inputClasses = ["form-control"];
    const note = props.noteSettings && props.noteSettings.visibility ? <label style={{textTransform: 'none'}}>{props.noteSettings.note}</label> : null

    if (props.invalid && props.shouldValidate && props.touched) {
        inputClasses.push("Invalid");
    }

    switch ( props.elementType ) {
        case ( 'input' ):
            inputElement = <input
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
            break;
        case ( 'textarea' ):
            inputElement = <textarea
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
            break;
        case ( 'switch' ):
            inputElement = <Form.Check
                {...props.elementConfig}
                onChange={props.changed}
                label="Active" />;
            break;
        case ( 'select' ):
            inputElement = (
                <select
                    className={inputClasses.join(' ')}
                    value={props.value}
                    onChange={props.changed}
                    {...props.elementConfig}>
                    {props.elementConfig.options.map(option => (
                        <option key={option.value} value={option.value} disabled={option.disabled} selected={option.selected}>
                            {option.displayValue}
                        </option>
                    ))}
                </select>
            );
            break;
        default:
            inputElement = <input
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
    }

    return (
        <div className="form-group">
            <label>{props.label}</label>
            {inputElement}
            {note}
        </div>
    );

};

export default input;